export function buttonRequestContext(searchParams) {
  return {
    clientId: searchParams.get('client_id'),
    brand: searchParams.get('marca'),
    origin: searchParams.get('origem'),
  };
}
